import React, { useCallback, useState } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import { CloseIcon, SMSNodeIcon, ViberIcon, WhatsappIcon } from "../iconSet/IconSet";
import { sourceCustomStyles, targetCustomStyles } from "../workflowCanvas/CustomStyles";

type ViberNodePropsTypes = {
	id: string;
	data: {
		label: string;
		data: any;
	}
}

const ViberNode: React.FC<ViberNodePropsTypes> = ({ id, data }) => {
	
	const { deleteElements } = useReactFlow();
	const [isHovering, setIsHovering] = useState(false);

	const handleMouseOver = () => {
		setIsHovering(true);
	};

	const handleMouseOut = () => {
		setIsHovering(false);
	};

	const deleteNode = useCallback(() => {
		deleteElements({ nodes: [{ id }] });
	}, [id, deleteElements]);

	return (
		<div className={`viber-node`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
				<ViberIcon width='1.5rem'/>
				<span>{data.label} - (Dissemination)</span>
				{isHovering && (
					<div className={`node-close-ico`} onClick={deleteNode}>
						<CloseIcon width='1rem' color="var(--color-main-red)"/>
					</div>
				)}  
				<Handle id='pdf-target-a' type='target' position={Position.Top} style={{...targetCustomStyles, background: "blue"}}/>
				{/* <Handle id='pdf-source-a' type='source' position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow"}}/> */}
		</div>
	);
};

export default ViberNode;
